"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var GasBottle = function GasBottle(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "24",
    height: "24"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M18.26,18V8.25a3,3,0,0,0-.38-1.83,3.33,3.33,0,0,0-1.23-1.11l.57-1.1-1-.52-.57,1.12a10.26,10.26,0,0,0-1.29-.42l-.26-.31V.31s0-.13-.31-.21A10.64,10.64,0,0,0,12.44, 0h-.07A10.64,10.64,0,0,0,11.06.1c-.32.07-.31.21-.31.21V4.09l-.26.31A10.3,10.3,0,0,0,8.74,5L8.17,3.89l-1,.52.6,1.17h0a2.82,2.82,0,0,0-.81.84,3,3,0,0,0-.38, 1.83V18s-.07,1.39.43,1.89c0,0-.34.34-.34.55v1.83s0,.55.93,1a12.14,12.14,0,0,0,4.8.75h.07a12.14,12.14,0,0,0,4.8-.75c.88-.49.93-1, .93-1V20.4c0-.21-.34-.55-.34-.55C18.33,19.35,18.26,18,18.26,18Z",
    style: {
      fill: '#024965'
    }
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12.68,21.17c-4.58,0-5.27-.56-5.34-.63a.15.15,0,0,1,.21-.22s.75.54,5.12.54c3.64,0,4.55-.55,4.56-.56a.16.16,0,0,1, .21,0,.15.15,0,0,1,0,.21S16.46,21.17,12.68,21.17Z",
    style: {
      fill: '#fff'
    }
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12.49,4.82a4.67,4.67,0,0,1-1.41-.21.15.15,0,0,1,.1-.29,4.33,4.33,0,0,0,2.53,0,.15.15,0,0,1,.1.29A4,4,0,0,1,12.49,4.82Z",
    style: {
      fill: '#fff'
    }
  }));
};

var _default = GasBottle;
exports["default"] = _default;